var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-sheet', [_c('p', {
    staticClass: "page-text--sm grey-9--text mb-4"
  }, [_vm._v("상태")]), _c('v-select', _vm._b({
    staticClass: "v-input--x-small v-input--noborder",
    attrs: {
      "hide-details": "",
      "prepend-inner-icon": "icon-dot"
    },
    on: {
      "change": function (state) {
        return _vm.$emit('put', {
          _id: _vm.value._id,
          state
        });
      }
    },
    model: {
      value: _vm.state,
      callback: function ($$v) {
        _vm.state = $$v;
      },
      expression: "state"
    }
  }, 'v-select', {
    items: _vm.items
  }, false)), _c('div', {
    staticClass: "mt-n16"
  }, [_vm.state == 'MATCHING_ON_GOING' ? _c('i', {
    staticClass: "icon icon-dot icon-dot--primary"
  }) : _vm.state == 'MATCHING_COMPLETE' ? _c('i', {
    staticClass: "icon icon-dot icon-dot--green"
  }) : _vm.state == 'MEETINGS_PROGRESS' ? _c('i', {
    staticClass: "icon icon-dot icon-dot--yellow"
  }) : _vm.state == 'MEETINGS_COMPLETE' ? _c('i', {
    staticClass: "icon icon-dot icon-dot--secondary"
  }) : _vm._e()])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }